export default "__VITE_ASSET__BeLI$_JC__"